import React from "react";
import { Fab as MuiFab } from "@mui/material";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import { useFabStyles } from "./css";

interface IFab {
  size?: "small" | "large" | "medium";
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: "default" | "menu";
  className?: string;
}

function Fab(props: IFab) {
  const {
    size = "small",
    icon,
    onClick,
    variant = "default",
    className,
  } = props;

  const { classes } = useFabStyles();
  const isMenu = variant === "menu";

  return (
    <MuiFab
      size={size}
      onClick={isMenu ? undefined : onClick}
      className={`${isMenu ? classes.fabMenu : classes.fab} ${className ?? ""}`}
      component={isMenu ? "div" : "button"}
      disabled={isMenu}
      disableRipple={isMenu}
      disableFocusRipple={isMenu}
    >
      {icon ?? <FlipCameraAndroidIcon className={classes.icon} />}
    </MuiFab>
  );
}

export default Fab;
